const STAGING_URL = "https://lit-ocean-80388.herokuapp.com/";
const TEST_URL = "http://2c18-203-115-91-24.ngrok.io/";
const LIVE_URL = "https://asthma-go.herokuapp.com/";

export const BASE_URL = LIVE_URL;

const PREFIX_URL = BASE_URL + "v1";

export const API = {
  LOGIN: `${PREFIX_URL}/user/login`,
  LOGOUT: `${PREFIX_URL}/user/logout`,
  RESET_PASSWORD: `${PREFIX_URL}/user/resetPassword`,
  FORGOT_PASSWRD: `${PREFIX_URL}/user/forgot-password`,
  UPLOAD_FILE: `${PREFIX_URL}/fileUpload`,
  USERS: (params = "") => `${PREFIX_URL}/user?${params}`,
  CHANGE_PASSWORD_ADMIN: `${PREFIX_URL}/user/changePassword`,
  PERMISSION: `${PREFIX_URL}/permission`,
  HOSPITAL_PROVIDER: `${PREFIX_URL}/hosptialProvider`,
  DEVICES: (params = "") => `${PREFIX_URL}/device?${params}`,
  GET_DASHBOARD_DATA: `${PREFIX_URL}/dashboard`,
  SEND_NOTIFICATION: `${PREFIX_URL}/sendNotification`,
  USER_REPORT: (params = "") => `${PREFIX_URL}/user/deviceData?${params}`,
  OXY_TEST_DATA: (params = "") =>
    `${PREFIX_URL}/user/oxyTestSessionData?${params}`,
};

export const RESPONSE = {
  success: 200,
  unAuthorized: 401,
};
